/* DOCUMENT INFORMATION
	- Author:   Dominik Maszczyk
	- Email:    Skitionek@gmail.com
	- Created:  2019-06-06
*/

export const QUERY_KINDS = [
	'Mutation', 'Query', 'Subscription'
];

export const MODULE_NAME = 'gql-generator-node';